import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "app-avatar",
	templateUrl: "./avatar.component.html"
})
export class AvatarComponent implements OnInit {
	@Input() name: string;
	@Input() image: string;

	ngOnInit() {}

	getAvatar(): string {
		if (this.name === null) {
			return "";
		}

		const nome = this.name.split(" ");
		if (nome.length > 1) {
			return `${nome[0].charAt(0)}${nome[nome.length - 1].charAt(0)}`;
		}
		return nome[0].charAt(0);
	}
}
